module.exports = __webpack_public_path__ + "static/media/banner-carrefour.36918fc0.webp";